/*
 * @format
 * @flow
 */

import React from 'react';
import { FlexRow, FlexCol, NumberField, Label, Text } from 'sarsaparilla';

import { animalTypeToString } from 'ui-permit/src/utils/utils';

type propTypes = {
    handleAnimalChange: Function,
    animal: Object,
    index: number,
    maxAnimalQuantity: number,
};

export default function AnimalItem({ animal, index, maxAnimalQuantity, handleAnimalChange }: propTypes) {
    const handleChange = (input) => {
        const newAnimal = { ...animal, amount: input };
        handleAnimalChange(index, newAnimal);
    };

    const animalName = animalTypeToString.get(animal.type);
    return (
        <FlexRow>
            <FlexCol xs={7} sm={5} xl={3}>
                <Label htmlFor="animal-amount" title={animalName}>
                    Type
                </Label>
                <Text>{animalName}</Text>
            </FlexCol>
            <FlexCol xs={5} sm={4} xl={2}>
                <Label htmlFor={`animal-amount-${index}`}>Quantity</Label>
                <NumberField
                    id={`animal-amount-${index}`}
                    units="animals"
                    max={maxAnimalQuantity}
                    value={animal.amount}
                    onChange={handleChange}
                />
            </FlexCol>
        </FlexRow>
    );
}
